<template>
  <div>
    <div class="container-fluid font-sarabun bg-white colunm-border-left">
      <div class="row mt-3">
        <div class="col-md-6 text-center p-5">
          <h2 class="text-uppercase font-basetheme font-kanit">
            <span class="mdi mdi-numeric-1-circle font-3x font-secondtheme"></span>
            <br />Vision
          </h2>
          <div class="font-1x font-grey pd-left-4x5 pd-right-4x5">
            <span
              class="font-1x3"
            >“เราเป็นผู้จัดหาและพัฒนาเทคโนโลยีแบบครบวงจร เพื่อตอบโจทย์ธุรกิจทั้งในประเทศและต่างประเทศ”</span>
            <br />
          </div>
        </div>
        <div class="col-md-6 text-center p-0">
          <img src="@/assets/img/service/startup.jpg" class="w-100" alt />
        </div>
      </div>
    </div>

    <div class="container-fluid font-sarabun bg-white colunm-border-right">
      <div class="row mt-3">
        <div class="col-md-6 text-center p-0">
          <img src="@/assets/img/service/digital-marketing.jpg" class="w-100" alt />
        </div>
        <div class="col-md-6 text-center p-5">
          <h2 class="text-uppercase font-basetheme font-kanit">
            <span class="mdi mdi-numeric-2-circle font-3x font-secondtheme"></span>
            <br />Mission
          </h2>
          <div class="font-1x font-grey pd-left-4x5 pd-right-4x5">
            “
            <ul class="text-left font-1x3">
              <li>
                <strong class="font-secondtheme">พันธกิจที่ 1</strong> เป็นผู้นำสินค้าและบริการสู่ระดับภูมิภาคและระดับสากล
              </li>
              <li>
                <strong class="font-secondtheme">พันธกิจที่ 2</strong> เป็นผู้พัฒนาเทคโนโลยีและซอฟต์แวร์เพื่อตอบโจทย์ธุรกิจของคนไทย
              </li>
              <li>
                <strong class="font-secondtheme">พันธกิจที่ 3</strong> เป็นผู้ให้คำปรึกษาทางด้านเทคโนโลยีและทางด้านธุรกิจ
              </li>
            </ul>
            <br />
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid font-sarabun bg-white colunm-border-left">
      <div class="row mt-3">
        <div class="col-md-6 text-center p-5">
          <h2 class="text-uppercase font-basetheme font-kanit">
            <span class="mdi mdi-numeric-3-circle font-2x font-secondtheme"></span>
            <br />Corporate Value
          </h2>
          <div class="font-1x font-grey pd-left-4x5 pd-right-4x5">
            “
            <ul class="text-left font-1x">
              <li>
                <strong class="font-secondtheme">V</strong> - Velocity : มุ่งให้บริการและการทำงานที่รวดเร็วเพื่อตอบสนองต่อความต้องการลูกค้า
              </li>
              <li>
                <strong class="font-secondtheme">A</strong> - Adapt : มุ่งปรับกระบวนการทำงานให้ทันสมัยและเหมาะสมกับเป้าหมายที่จะดำเนินการ
              </li>
              <li>
                <strong class="font-secondtheme">L</strong> - Learn : มุ่งสร้างสรรค์เทคโนโลยี และ นวัตกรรม พร้อมเรียนรู้สิ่งใหม่ๆ เพื่อพัฒนาสินค้าและบริการ
              </li>
              <li>
                <strong class="font-secondtheme">U</strong> - Unique : มุ่งส่งมอบสินค้าและบริการที่เป็นมีความพิเศษและเป็นเอกลักษณ์
              </li>
              <li>
                <strong class="font-secondtheme">E</strong> - Ethic : มุ่งรักษาและปฏิบัติด้วยความมีจริยธรรมและจรรยาบรรณต่อบริษัท
              </li>
            </ul>
            <br />
          </div>
        </div>
        <div class="col-md-6 text-center p-0">
          <img src="@/assets/img/about/people.jpg" class="w-100" alt />
        </div>
      </div>
    </div>

    <div
      class="container-fluid font-sarabun bg-white mt-3 pt-5 colunm-border-left colunm-border-right"
    >
      <h2 class="text-uppercase font-basetheme font-kanit text-center">
        <span class="mdi mdi-numeric-4-circle font-2x font-secondtheme"></span>
        <br />Business Overview
      </h2>
      <div class="row mt-3">
        <div class="col-md-12 text-center p-0">
          <img src="@/assets/img/about/bizoverview.png" class="w-100" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>